import apiV2 from '../../api/v2';

export interface DmQuickstartView {
    id: string;
    name: string;
    description: string | null;
}

export async function fetchQuickstarts(patientId: string): Promise<DmQuickstartView[]> {
    const response = await apiV2.get<DmQuickstartView[]>(
        `/patients/${encodeURIComponent(patientId)}/workflow/in-treatment/quickstarts`
    );
    return response.data;
}
